/**
 * Copyright Aquera Inc 2025
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { html, CSSResultArray, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { styles } from './nile-carousel-item.css';
import NileElement from '../../internal/nile-element';

/**
 * Nile carousel-item component.
 *
 * @tag nile-carousel-item
 *
 */
@customElement('nile-carousel-item')
export class NileCarouselItem extends NileElement {
 
  public static get styles(): CSSResultArray {
    return [styles];
  }

  public render(): TemplateResult {
    return html`
      <div part="base" class="carousel-item">
        <slot></slot>
      </div>
    `;
  }
}

export default NileCarouselItem;

declare global {
  interface HTMLElementTagNameMap {
    'nile-carousel-item': NileCarouselItem;
  }
}

